<template>
  <div class="product-item">
    <div class="product-head clearfix">
      <img
        class="f-left"
        :src="productBase.icon"
        alt
      />
      <div class="f-left">
        <p class="title">{{ productBase.title }}</p>
        <slot name="desc"></slot>
      </div>
      <div
        class="f-right"
        style="line-height:44px;"
      >
        <span v-if="checked">快递发票 {{ amount }}元</span>
      </div>
    </div>
    <div class="contact clearfix">
      <div class="clearfix form">
        <a-form layout="vertical">
          <a-form-item
            label="收件人"
            class="f-left input name"
          >
            <a-input
              size="large"
              v-model="contact.name"
              placeholder="请输入收件人姓名"
              @change="onChange"
            />
          </a-form-item>
          <a-form-item
            label="联系电话"
            class="f-left input phone"
          >
            <a-input
              size="large"
              v-model="contact.phone"
              placeholder="请输入联系人电话号码"
              @change="onChange"
            />
          </a-form-item>
          <div class="f-left clearfix address">
            <a-form-item
              label="收件地址"
              class="input"
            >
              <a-input
                size="large"
                v-model="contact.address"
                placeholder="请输入收件人地址"
                @change="onChange"
              />
            </a-form-item>
          </div>
        </a-form>
      </div>
      <div class="des">
        <span>{{ products.length ? products[0].services[0].productName : '行程单' }}</span>
        <div class="f-right">
          <span class="f-left" v-if="airline === '8L'">快递发票{{ amount }}元（发票请联系{{ hotline }}）</span>
          <span class="f-left" v-else>快递发票{{ amount }}元（默认手撕发票）</span>
          <a-checkbox
            class="box"
            :checked="checked"
            @change="onCheck"
          ></a-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNetFareAmount } from '@/assets/js/util'
import getAppInfo from '@/utils/from'

export default {
  data () {
    return {
      contact: {
        name: '',
        phone: '',
        address: ''
      },
      checked: false,
      hotline: getAppInfo()?.hotline,
      airline: window.__MICRO_ROOT__?.airline
    }
  },
  props: {
    type: {
      type: String,
      required: true,
      default: 'itinerary'
    },
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    productBase: [Object, Array]
  },
  computed: {
    amount () {
      const { products } = this

      return products.length ? getNetFareAmount(products[0].services[0].fareDetails) : 15
    }
  },
  methods: {
    onChange () {
      const { contact, checked, products } = this
      this.$emit('change', {
        ...contact,
        invoice: checked ? 'Y' : 'N'
      }, products[0].services[0])
    },
    onCheck (e) {
      const { contact, products } = this
      const checked = this.checked = e.target.checked

      this.$emit('change', {
        ...contact,
        invoice: checked ? 'Y' : 'N'
      }, products[0].services[0])
    }
  }
}
</script>
